<!-- @if (detailData?.company?.is_subcontracting) {
  <div
    class="report-preview p-2 border-primary text-primary border border-2 rounded my-2 text-center fw-semibold bg-white"
  >
    {{ detailData?.company?.company_name }} is a Prime Contractor
  </div>
} -->
<div class="my-3">
  <button class="btn btn-md btn-danger" (click)="onEmailReport()">
    <i class="fa-regular fa-file-pdf fs-4"></i>
  </button>
</div>

<div class="preview-report p-lg-5 p-2 shadow bg-white text-black">
  @if (detailData?.id) {
    @if (!detailData?.additional_info?.hide_header) {
      <div class="header-container">
        <div class="subscriber_company_information_section">
          @if (!detailData?.additional_info?.hide_subscriber_header_details) {
            <div class="strong">
              {{ subscriberInfo?.name }}
            </div>
            <div>{{ subscriberInfo?.address }}</div>
            <div>{{ subscriberInfo?.city }}</div>
            @if (subscriberInfo?.mobile_number) {
              <div>Ph: {{ subscriberInfo?.mobile_number }}</div>
            }
            <div>{{ subscriberInfo?.email }}</div>
          }
        </div>
        <div class="text-center">
          @if (subscriberInfo?.logo_url) {
            <img
              [ngClass]="largeView ? 'logo_img_large' : 'logo_img_mob'"
              alt="placeholder_logo"
              src="{{ subscriberInfo?.logo_url }}"
            />
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-1 px-3 uploadLogo text-center"
            >
              Update Logo
            </div>
          } @else {
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-4 px-3 uploadLogo text-center ms-2"
            >
              Upload Logo
            </div>
          }
        </div>
      </div>
    }
    <div class="report-type-heading">Incident Report</div>
    <!--CLIENT INFORMATION SECTION-->
    @if (!detailData?.company?.is_subcontracting) {
      <div class="client_information_section">
        <div>{{ detailData?.company?.company_name }}</div>
        @if (!detailData?.additional_info?.hide_client_detail) {
          @if (detailData?.company?.custom_address) {
            <div class="gt-multi-line">
              {{ detailData?.company?.custom_address }}
            </div>
          }
          <div>
            {{ detailData?.company?.report_address?.address }}
          </div>
          <div>
            {{ detailData?.company?.report_address?.city }}
          </div>
        }
      </div>
    }
    <div class="patrol-table mt-5">
      @if (timeZoneData?.time_zone && timeZoneData?.time_zone_diff) {
        <div
          style="
            font-size: 10px;
            padding-bottom: 0.5rem;
            color: #333;
            font-weight: bold;
            font-style: italic;
          "
        >
          Timestamps shown in
          {{ timeZoneData?.time_zone }}
          {{ timeZoneData?.time_zone_diff }}
        </div>
      }
      <table style="width: 100%; max-width: 100%" class="responsive">
        <tr>
          <td class="cell-heading">Date</td>
          <td>
            {{
              (detailData?.additional_info?.report_date
                ? detailData?.additional_info?.report_date
                : today
              ) | date: "dd MMM yyyy"
            }}
          </td>
          <td class="cell-heading">Reference No.</td>
          <td>{{ detailData?.incident_key }}</td>
        </tr>
        <tr>
          <td class="cell-heading">Incident Type</td>
          <td colspan="3">
            @if (detailData?.incident_types?.length) {
              @for (
                iType of
                  detailData?.incident_types;
                track $index;
                let first = $first, last =
                  $last
              ) {
                {{ iType?.name }}{{ last ? "" : ", " }}
              }
            } @else {
              {{ detailData?.incident_type }}
            }
          </td>
        </tr>
        <tr>
          <td class="cell-heading">Incident Time</td>
          <td colspan="3">
            {{ detailData?.incident_time | date: "dd MMM yyyy HH:mm" }}
          </td>
        </tr>
        <tr>
          <td class="cell-heading">Resolution Time</td>
          <td colspan="3">
            {{ detailData?.resolution_time | date: "dd MMM yyyy HH:mm" }}
          </td>
        </tr>
        <tr>
          <td class="cell-heading">Location</td>
          <td colspan="3">
            <span class="fw-semibold">{{
              detailData?.site?.company_name
            }}</span>
            &emsp;
            {{ detailData?.site?.address?.full_address }}
          </td>
        </tr>
        @if (!detailData?.additional_info?.hide_incident_created_guard_name) {
          <tr>
            <td class="cell-heading line-height">Reported By</td>
            <td colspan="3">
              <div class="d-flex">
                <div class="pe-2">
                  <div class="gt-multi-line line-height fs-6">
                    {{ detailData?.subscriber_user?.full_name }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        }
        <tr>
          <td class="cell-heading line-height">Details</td>
          <td colspan="3">
            <div class="d-flex">
              <div class="pe-2">
                <div class="gt-multi-line line-height fs-6">
                  {{ detailData?.information }}
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="cell-heading line-height">Resolution</td>
          <td colspan="3">
            <div class="d-flex">
              <div class="pe-2">
                <div class="gt-multi-line line-height fs-6">
                  {{ detailData?.corrective_actions }}
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    @if (incidentCommentFiles?.length) {
      <div class="report-summary-heading mb-2">
        <div class="d-flex mt-3 mb-1 align-items-center">
          <div>Incident Details</div>
        </div>
      </div>
    }
    @if (sumamaryTableData?.length) {
      @if (largeView) {
        <div class="patrol-table">
          <table style="width: 100%; max-width: 100%">
            <thead>
              <tr>
                <th style="text-align: center">ID</th>
                <th>Time</th>
                <th>Event Type</th>
                <th style="border-left: hidden"></th>
                @if (!detailData?.additional_info?.hide_guard_column) {
                  <th>Guard</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of sumamaryTableData; track row; let i = $index) {
                <tr
                  style="
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  "
                  id="section_up{{ i + 1 }}"
                >
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    style="text-align: center"
                    class="line-height"
                  >
                    {{ i + 1 }}
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="line-height"
                  >
                    {{
                      (row?.user_provided_timestamp
                        ? row?.user_provided_timestamp
                        : row?.updated_at
                      ) | date: "dd MMM yyyy HH:mm"
                    }}
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="uppercase line-height"
                  >
                    <a
                      class="cursor-pointer"
                      (click)="
                        scrollToSection($event, 'section_down' + (i + 1))
                      "
                      style="color: #00538d"
                    >
                      {{
                        row?.event_action === 11
                          ? "Photo (Source: Device Library)"
                          : "Photo (Source: Camera)"
                      }}
                    </a>
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    style="border-left: hidden"
                  >
                    <div class="d-flex">
                      <div class="gt-multi-line line-height fs-6">
                        {{ row?.detail }}
                      </div>
                    </div>
                  </td>
                  @if (!detailData?.additional_info?.hide_guard_column) {
                    <td
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="line-height"
                    >
                      {{ row.user_name }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mt-3">
          <tbody>
            @for (row of sumamaryTableData; track row; let i = $index) {
              <tr id="section_up{{ i + 1 }}">
                <td class="bg-body-secondary text-body-emphasis">
                  <div class="d-flex justify-content-between">
                    <div
                      class="line-height small text-secondary d-flex"
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    >
                      {{
                        (row?.user_provided_timestamp
                          ? row?.user_provided_timestamp
                          : row?.updated_at
                        ) | date: "dd MMM yyyy HH:mm"
                      }}
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between small text-secondary"
                  >
                    <div
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="uppercase line-height"
                    >
                      @if (row?.file) {
                        <a
                          class="cursor-pointer"
                          (click)="
                            scrollToSection($event, 'section_down' + (i + 1))
                          "
                          style="color: #00538d"
                        >
                          {{
                            row?.event_action === 11
                              ? "Photo (Source: Device Library)"
                              : "Photo (Source: Camera)"
                          }}
                        </a>
                      } @else {
                        {{
                          row?.event_action === 11
                            ? "Photo (Source: Device Library)"
                            : "Photo (Source: Camera)"
                        }}
                      }
                    </div>
                    @if (!detailData?.additional_info?.hide_guard_column) {
                      <div
                        [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                        class="line-height"
                      >
                        {{ row.user_name }}
                      </div>
                    }
                  </div>
                  <div [ngClass]="row?.is_deleted ? 'opacity-25' : ''">
                    <div class="d-flex pt-2">
                      <div class="gt-multi-line line-height fs-6">
                        {{ row.detail }}
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    <!-- REPORT SUMMARY -->
    <!-- DETAILS SECTION -->
    <div
      class="mt-5"
      style="box-decoration-break: clone; -webkit-box-decoration-break: clone"
    >
      @for (item of incidentCommentFiles; track item; let i = $index) {
        @if (item?.file && !item?.is_deleted) {
          <div id="section_down{{ i + 1 }}">
            <div class="d-flex mb-2">
              <div
                [ngClass]="
                  largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                "
              >
                @if (item?.download_url) {
                  <a
                    href="{{ item.download_url }}"
                    style="text-decoration: none"
                  >
                    <button class="btn btn-primary btn-sm mb-3">
                      Download Video
                    </button>
                  </a>
                }
                <!--TIMESTAMP-->
                <div
                  style="font-weight: 600"
                  class="key-value d-flex gap-1 mb-3"
                >
                  {{
                    (item?.user_provided_timestamp
                      ? item?.user_provided_timestamp
                      : item?.updated_at
                    ) | date: "dd MMM yyyy HH:mm"
                  }}
                </div>
                <!-- GPS ACCURACY NOTIFICATION-->
                @if (item?.gps?.source) {
                  <div class="warning">
                    @if (item?.gps?.source == 1) {
                      Location Accuracy: Low
                    }
                    @if (item?.gps?.source == 2) {
                      Location Accuracy: Very Low
                    }
                  </div>
                }
                <!--SECTION: EVENT LOCATION-->
                @if (item?.gps?.lat && item?.gps?.lon) {
                  <div style="margin-bottom: 2rem">
                    <div class="key-label text-secondary">Event Location</div>
                    <div
                      style="max-width: 100%; height: 150px; object-fit: none"
                      class="small"
                    >
                      <gtapp-map-leaflet
                        [customMapConfig]="{ showSimpleStaticMap: true }"
                        [latLon]="{
                          markerTooltip: item?.event_by,
                          lat: item?.gps?.lat,
                          lon: item?.gps?.lon,
                        }"
                        [mapId]="'map_' + i"
                      ></gtapp-map-leaflet>
                    </div>
                  </div>
                }
                <!--SECTION:  PHOTO COMMENT/NOTES-->
                <div class="d-inline">
                  <div class="gt-multi-line">
                    @if (item?.detail) {
                      <span>
                        {{ item?.detail }}
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                @if (
                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                    item?.file_extension
                  )
                ) {
                  <video
                    controls
                    style="
                      max-height: 100%;
                      max-width: 100%;
                      display: flex;
                      width: 100%;
                    "
                  >
                    <source src="{{ item?.file }}" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                } @else {
                  <img
                    (click)="onOpenImage($event, item)"
                    src="{{ item?.file }}"
                    style="max-height: 100%; max-width: 100%; display: flex"
                  />
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
